import request from "../utils/request";
const deptCodeApi = {
  QrCodeList: '/qr_code/list',
  QrCode: '/qr_code'
}
export function getQrCodeListApi(params) {
  return request({
    url: deptCodeApi.QrCodeList,
    method: 'get',
    params
  })
}
export function updateQrCodeApi(data) {
  return request({
    url: deptCodeApi.QrCode,
    method: 'post',
    data
  })
}
export function removeQrCodeApi(data) {
  return request({
    url: deptCodeApi.QrCode,
    method: 'delete',
    data
  })
}
